import { getAssetByTypeAndSource } from 'Pods/ThreeDStudio/Shared/Utils/getAssetByTypeAndSource'
import { getInputImageAsset } from 'Pods/ThreeDStudio/Shared/Utils/getInputImageAsset'
import {
  ACTION,
  DEFAULT_TEXTURE_SETTINGS,
  PROVIDER,
  TEXTURE_ACTION_TAB,
  VIEWER_SIDEBAR_TAB,
} from 'Pods/ThreeDStudio/Store/constants'

import { deriveMaterialForHyper3d } from './deriveMaterialForHyper3d'
import { getModelFormatOutput } from './getModelFormatOutput'
import { normalizeRunAttributes } from './normalizeRunAttributes'

/**
 * Builds the ThreeDStudio store patch for a Hyper3D retexture-pro run.
 * Mirrors parseTencentRetextureProData: reads the user-uploaded texture image
 * from inputAssets, the source 3D model from outputAssets, derives material
 * from the stored materialMode, infers modelFormatOutput from the generated
 * 3d_model URL when not explicit, and opens the viewer sidebar on TEXTURE.
 *
 * @param {Object} openedModel - Run object from the library
 * @returns {Object} parsedData - ThreeDStudio store patch
 */
export const parseHyper3dRetextureProData = (openedModel) => {
  const {
    prompt,
    enablePbr,
    modelFormatOutput: rawModelFormatOutput,
    inputAssets,
    outputAssets,
    generatorSessionId,
    id: sessionId,
  } = openedModel
  const { materialMode } = normalizeRunAttributes(openedModel.providerRunAttributes)
  const material = deriveMaterialForHyper3d(materialMode)
  const enhancedProvider = PROVIDER.TRIPO3D
  const enhancedAction = ACTION.RETEXTURE
  const activeTextureActionTab = prompt ? TEXTURE_ACTION_TAB.TEXT : TEXTURE_ACTION_TAB.IMAGE

  const {
    assetId: inputThreeD,
    fileUrl: inputThreeDUrl,
  } = getAssetByTypeAndSource(outputAssets, '3d_model', 'ai_generated')
  const modelFormatOutput = getModelFormatOutput({
    modelFormatOutput: rawModelFormatOutput,
    modelUrl: inputThreeDUrl,
  })
  const {
    assetId: inputImage,
    fileUrl: inputImageUrl,
  } = getInputImageAsset(inputAssets)

  const schema = { enhancedAction, enhancedProvider }
  const generation = { sessionId, generatorSessionId }
  const viewer = { fileFormat: modelFormatOutput, inputThreeD, material }
  const textureSettings = {
    inputImage,
    inputImageUrl,
    prompt: prompt ?? DEFAULT_TEXTURE_SETTINGS.prompt,
    material,
    enablePbr,
  }

  const ui = {
    isModelSettingsOpen: false,
    isViewerSidebarOpen: true,
    activeViewerSidebarTab: VIEWER_SIDEBAR_TAB.TEXTURE,
    activeTextureActionTab,
  }

  return {
    openedModel,
    schema,
    textureSettings,
    ui,
    generation,
    viewer,
  }
}
